import { useEffect, type RefObject } from "react"
import { queryHotspots } from "../utils"

export const useHotspotListeners = (
	containerRef: RefObject<HTMLElement | null>,
	onSelect: (partIndex: string) => void
) => {
	useEffect(() => {
		const container = containerRef.current
		if (!container) return

		const handler = (evt: Event) => {
			const target = evt.currentTarget as HTMLElement | null
			if (!target) return
			onSelect(target.dataset.itemNumber ?? "")
		}

		const attach = () => {
			queryHotspots(container).forEach((el) => {
				el.style.cursor = "pointer"
				el.addEventListener("mouseover", handler)
			})
		}

		const detach = () => {
			queryHotspots(container).forEach((el) => {
				el.removeEventListener("mouseover", handler)
			})
		}

		const observer = new MutationObserver(() => {
			detach()
			attach()
		})
		observer.observe(container, { childList: true, subtree: false })

		attach()

		return () => {
			observer.disconnect()
			detach()
		}
	}, [containerRef, onSelect])
}
